/** @ngInject */
export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        const type = this.application.applicationType.slug;
        this.templateUrl = require(`./templates/${type}.html`);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/help/help.controller.js